import { render, staticRenderFns } from "./PackageIcon.vue?vue&type=template&id=4377bbf4"
import script from "./PackageIcon.vue?vue&type=script&lang=js"
export * from "./PackageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports